import Firebase from 'firebase';


export let FirebaseMain = null;

export function removePreviousInstance() {
  FirebaseMain = null;
}

export function initFirebase(url, optionParameter) {
  removePreviousInstance();

  if (!optionParameter) {
    FirebaseMain = new Firebase(url);
  } else {
    FirebaseMain = new Firebase(url, optionParameter);
  }
}
